import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { routerUrlToAbsolute } from '../utils/url-utils';

export const authenticatedGuard: CanActivateFn = async (_route, state) => {
  const keycloak = inject(KeycloakService);
  const isLoggedIn = await keycloak.isLoggedIn();
  if (isLoggedIn) {
    return true;
  }

  await keycloak.login({
    redirectUri: routerUrlToAbsolute(state.url),
    locale: 'en'
  });
  return false;
};
